import { Send } from "lucide-react";
import { DataTable } from "../components/DataTable";
import { Badge, Button, Card, EmptyState, Skeleton } from "../components/ui";
import { useTelemedicine } from "../data/platform-data";

export function TelemedicinePage() {
  const query = useTelemedicine();
  return (
    <Card
      title="Elegibilidade MobiMedical"
      description="Somente dados comerciais e de provisioning. Nenhum dado clínico."
    >
      {query.isLoading && <Skeleton className="table-skeleton" />}
      {query.error && (
        <EmptyState title="Falha ao carregar telemedicina" description={query.error.message} />
      )}
      {!query.isLoading && !query.error && (
        <DataTable
          rows={query.data ?? []}
          getKey={(entry) => entry.id}
          columns={[
            { key: "person", header: "Beneficiário", render: (entry) => entry.person },
            { key: "family", header: "Família", render: (entry) => entry.family },
            { key: "external", header: "ID externo", render: (entry) => entry.externalId },
            {
              key: "status",
              header: "Status",
              render: (entry) => (
                <Badge
                  tone={
                    entry.status === "ACTIVE" || entry.status === "ATIVO" ? "success" : "warning"
                  }
                >
                  {entry.status}
                </Badge>
              ),
            },
            { key: "firstAccess", header: "Primeiro acesso", render: (entry) => entry.firstAccess },
            {
              key: "action",
              header: "",
              render: () => (
                <Button variant="ghost">
                  <Send size={15} /> Reenviar acesso
                </Button>
              ),
            },
          ]}
        />
      )}
    </Card>
  );
}
